import React from "react";
import { Table as Table2 } from '@devexpress/dx-react-grid-material-ui';
import Select from '@material-ui/core/Select';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import './TableCell.css';
import omit from 'lodash/omit';
import { isAllowed, authRoles } from "../../../../auth/auth";

export const TableCell = (props) => {
    const { column } = props;
    let simpleProps = omit(props, ['changeRole', 'toggleActivity', 'resendInvitation', 'confirmAction', 'user']);
    if (column.name === 'userRole') {
        return <RoleCell {...simpleProps} user={props.user} confirmAction={props.confirmAction} />;
    } else if (column.name === 'actions') {
        return <ActionsCell {...simpleProps} confirmAction={props.confirmAction} />;
    }
    // else if (column.name === '') {
    //     return <MenuCell {...simpleProps} />;
    // }

    return <Table2.Cell {...simpleProps} />;
};

const RoleCell = ({ value, style, user, confirmAction, ...restProps }) => {
    let row = restProps.row;
    return (
        <Table2.Cell>
            <Select
                value={value}
                onChange={(event) => confirmAction('roleChange', row, event)}
                inputProps={{
                    name: 'filterByRole',
                    id: 'filterByRole',
                }}
                style={{ minWidth: '100px' }}
            >
                {isAllowed(user, authRoles.superAdmin) ? <MenuItem value={"ROLE_SUPER_ADMIN"}>Super Admin</MenuItem> : null}
                <MenuItem value={'ROLE_ADMIN'}>Admin</MenuItem>
                <MenuItem value={'ROLE_EDITOR'}>Editor</MenuItem>
                <MenuItem value={'ROLE_VIEWER'}>Viewer</MenuItem>
            </Select>
        </Table2.Cell>
    )
};

const ActionsCell = ({ value, style, row, confirmAction, ...restProps }) => {
    let action = row.status === 'active' ? 'inactive' : 'active';
    return (
        <Table2.Cell>
            <span className='actions-btn' onClick={row.status === 'invited' ? () => confirmAction('resendInvitation', row, null) : () => confirmAction('statusChange', row, action)}>
                {row.status === 'active' ? 'Deny access' : row.status === 'invited' ? 'Resend invitation' : 'Grant access'}
            </span>
        </Table2.Cell>
    )
};

//TODO fill with state and logic
const MenuCell = ({ value, style, ...restProps }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    function handleToggleMenu(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    return (
        <Table2.Cell style={{ textAlign: 'center' }}>
            <span>
                <MoreHoriz onClick={handleToggleMenu} />
            </span>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose}>Prompt reset password</MenuItem>
            </Menu>
        </Table2.Cell>
    )
};

export default TableCell;


// WEBPACK FOOTER //
// ./src/main/content/user-management/table-cell/TableCell.js